var map = {
	"./iq_test_default.json": [
		88830,
		8830
	],
	"./iq_test_default_eur.json": [
		10006,
		6
	],
	"./iq_test_default_gbp.json": [
		78302,
		8302
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10141;
module.exports = webpackAsyncContext;